// src/lib/utils/is_admin.js
import { browser } from '$app/environment';
import { page } from '$app/stores';
import { get } from 'svelte/store';
import { capture_supabase_error } from '$lib/utils/capture_supabase_error';

let cached_user_id = null;
let cached_is_admin = null;
let inflight_promise = null;

export async function get_is_admin() {
    if (!browser) return false;

    const page_store = get(page);
    const supabase = page_store?.data?.supabase;
    const session = page_store?.data?.session;

    if (!supabase || !session) {
        cached_user_id = null;
        cached_is_admin = null;
        inflight_promise = null;
        return false;
    }

    const current_user_id = session.user?.id || null;

    if (cached_user_id === current_user_id && cached_is_admin !== null) {
        return cached_is_admin;
    }

    if (inflight_promise) return inflight_promise;

    inflight_promise = (async () => {
        const { data, error } = await supabase.rpc('is_admin');
        inflight_promise = null;

        if (error) {
            capture_supabase_error(error, {
                message: 'is_admin RPC failed',
                operation: 'rpc',
                rpc: 'is_admin'
            });
            return false;
        }

        cached_user_id = current_user_id;
        cached_is_admin = Boolean(data);
        return cached_is_admin;
    })();

    return inflight_promise;
}
